<template>
    <div style="padding: 10px;">
        <Form :model="formData" :label-width="120" style="height: 550px;padding: 5px;overflow-y: auto;overflow-x: hidden;">
            <!--  <FormItem label="续费规则">
                会员有效期到期前15天为续费期，开启续费功能
      </FormItem>-->
            <FormItem label="账号等级">
                <tag color="success" size="large">{{formData.name}}</tag>
                <span style="color:#19be6b;">(已购)</span>
            </FormItem>
            <FormItem label="VIP升级权限">
                <div v-if="vipData.length>0">
                    <!-- <CheckboxGroup v-model="packages" @on-change="onRowChange" style="display: inline-block;"> -->
                    <div v-for="product in vipData" style="width:700px;">
                        <!-- <Checkbox class="labelTxt2" :label="product.funcname"></Checkbox> -->
                        
                        <span>
                            <span class="labelTxt2">{{product.funcname}} 数量(已购:{{product.alreadybought}})：</span>
                            <InputNumber :disabled="product._disable" placeholder="数量" :max="product.maxactive-product.alreadybought" :min="product.minctive" v-model="product.firstbought" @on-change="onRowChange" style="margin-right:100px;"></InputNumber>
                        </span>
                        <span style="padding-left:10px;" v-if="!product._disable">升级时长：{{vipOrderDays}}天</span>
                        <span class="labelTxt">
                            <router-link v-if="product.funccode==='000012'" @click.native="popClose" :to="{name:'mycloud'}" style="color:#19be6b;">管理文件仓库</router-link>
                        </span>
                        <span style="float:right;color:#515a6e;width: 150px;">
                            价格:
                            <span style="color:#ed4014;">{{(product.price*product.firstbought*vipOrderDays).toFixed(2)}} 元</span>
                        </span>
                    </div>
                    <!--  </CheckboxGroup> -->
                </div>
                <div v-else>
                    您还没有购买
                    <span style="color: #ed4014;">VIP升级包</span>，
                    传送门： >>
                    <router-link @click.native="popClose" :to="{name:'userstore',params:{id:'name2',t:new Date().getTime()}}" style="color:#19be6b;">订购升级包</router-link>
                    << </div> </FormItem> <Divider orientation="right">优惠信息</Divider>
                        <!-- 优惠信息 -->
                        <div>
                            <!--  升级包优惠 -->
                            <div style="width: 500px;margin-left:auto;text-align: left;">
                                <Card :bordered="false" dis-hover>
                                    <CellGroup>
                                        <Cell v-for="item in vipDiscount" :title="item.discountdesc" :key="item.id">
                                            <Icon v-if="item.selected" type="md-checkmark-circle" color="#19be6b" size="22" slot="extra" />
                                            <span v-else slot="extra">未满足</span>
                                        </Cell>
                                    </CellGroup>
                                </Card>
                            </div>
                            <div style="text-align:right;padding-right: 30px;">
                                <Coupon ref="mycoupon" @on-check="onCouponChecked" :isCouponShow="true" />
                            </div>
                        </div>
        </Form>
        <!-- 支付信息 -->
        <Divider orientation="right">支付信息</Divider>
        <div style="color:red;font-size: 18px;text-align: right;margin-right: 30px;">
            <!-- <span style="text-decoration: line-through;color:#c5c8ce;font-size: 14px;padding-right: 20px;">原价:{{orderamount}}元</span>  -->
            <span>实际支付:{{actualamount}}元</span>
        </div>
        <div class="pay-change" style="text-align: right;margin-right: 20px;margin-top:10px;">
            <span>选择支付方式：</span>
            <RadioGroup v-model="payChange">
                <Radio label="微信" border>
                    <i class="iconfont" style="color: #19c105;">&#xe650;</i>
                    <span style="color: #19c105;">微信</span>
                </Radio>
                <!--  <Radio label="支付宝" border>
                    <i class="iconfont" style="color: #00aaee;">&#xe618;</i>
                    <span style="color: #00aaee;">支付宝</span>
        </Radio>-->
            </RadioGroup>
        </div>
        <div class="invoiceContent">
            <span>发票信息：</span>
            <span v-if="invoiceType===1">普通发票</span>
            <span v-else-if="invoiceType===2">增值税专用发票</span>
            <span style="padding-left:5px;">{{invoiceHeaderName}}</span>
            <Button type="text" style="box-shadow:none;text-decoration:underline;color:#19be6b;" @click="showInvoice">修改</Button>
        </div>
        <Modal v-model="modalInvoice" width="700" :mask-closable="false">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="ios-information-circle"></Icon>
                <span>修改发票信息</span>
            </p>
            <div>
                <Invoice ref="myInvoice" :isModal="true" />
            </div>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelInvoice">取消</Button>
                <Button type="primary" size="large" @click="getInvoiceInfo">确定</Button>
            </div>
        </Modal>
        <QR ref="QRPayModal" @paySuccess="payComplete" @showAgreement="showPackageAgreement" />
        <Agreement ref="product_Vip_agreement" :isConfirm="true" @onAccept="onAgreementAccept" />
    </div>
</template>
<script>
import coupon from './coupon.vue'
import invoice from "./myinvoice.vue"
import qrModal from './qrpay.vue'
import ProductAgreement from './product_package_agreement.vue'
import moment from 'moment'
import ConstJson from '../../api/common/constjson'
import store from "../../store/"
let constJ = new ConstJson()
export default {
    data() {
        return {
            copydata: '',
            memberLevelChkInfo: null,
            firstVipData: [],
            vipData: [],
            sonheadertype: 1,
            myInvoiceHeader: {
                bankaccount: "",
                bankname: "",
                headercode: "",
                headername: "个人",
                headertype: 1,
                invoiceTotal: 0,
                mobilenumber: "",
                officeaddress: "",
                postaddress: "",
                postemail: "",
                postmobile: "",
            },
            invoiceHeaderName: '个人',
            invoiceType: 1,
            modalInvoice: false,
            promocode: {
                couponcode: '',
                agentcode: '',
            },
            userleveldata: null,
            actualamount: 0,
            orderamount: 0,
            vipDiscount: [],
            vipOrderDays: 0,
            agreementChecked: true,
            couponValue: '',
            payChange: '微信',
            modalRenewalPay: false,
            packages: [], //['一键上传', '云擎下载', '分屏权限', '文件仓库'],
            vipPackages: [],
            shopList: [{
                name: '',
            }],
        }
    },
    components: {
        'Coupon': coupon,
        "Invoice": invoice,
        'QR': qrModal,
        'Agreement': ProductAgreement,
    },
    created() {

    },
    computed: {
        percentageRemainingTime: function name(params) {
            return this.formData.remainingTime / 3.65
        },
        formData: function() {
            return this.shopList[0]
        },
        userData: function() {
            //console.log(store.state.user.myvippackage)
            return store.state.user
        },
        // vipData: function() {
        //     let vdata = null
        //     if (this.userData.myextentionpackage.length === 0) {
        //         return []
        //     }
        //     //vdata = this.vipPackages
        //     vdata = this.userData.myextentionpackage.funcs; //this.vipPackages
        //     return vdata
        // },
    },

    methods: {
        showCouponPrice(value) {
            this.actualamount = value.item.amount
            this.orderamount = value.item.oriamount
            console.log(value)
        },
        onCouponChecked(chkinfo) {
            this.memberLevelChkInfo = chkinfo
            if (chkinfo.isChecked) {
                this.$refs.mycoupon.countPromocode(this.actualamount, this.showCouponPrice)
            } else {
                this.$refs.mycoupon.clean()

                //还原到原始价格
                let _copy = JSON.parse(this.copydata)
                this.actualamount = _copy.oriprice

                //this.loadDefaultPackages(this.userleveldata)
            }
        },

        //下单前检查优惠码和运营商信息,可以强制下单
        checkOrder() {
            let r = this.$refs.mycoupon.getConfirmInfo()
            console.log(r)
            if (r.iswarning) {
                this.$Modal.confirm({
                    title: '提示',
                    content: '<p>' + r.rltdesc + '</p>',
                    cancelText: "返回",
                    okText: "下单",
                    onOk: () => {
                        this.renewVipPackages()
                    },
                    onCancel: () => {
                        return
                    }
                });
            } else {
                this.renewVipPackages()
            }
        },
        renewVipPackages() {
            let row = this.userleveldata
            //订购的扩展包
            let ext_func = []
            let _productId = row.productcode
            let _productOrderId = row.orderid

            let leftVipData = []
            var that = this
            this.packages.forEach(function(item) {
                let func = that.vipData.find(p => p.funcname === item)
                leftVipData.push(func)
            })
            leftVipData.forEach(function(item) {
                let arr = {
                    func_code: item.funccode,
                    func_name: item.funcname,
                    number: item.firstbought,
                }
                if (arr.number > 0) {
                    ext_func.push(arr)
                }
            })

            //优惠券和运营商编码
            this.promocode.couponcode = this.$refs.mycoupon.formCustom.couponValue
            this.promocode.agentcode = this.$refs.mycoupon.formCustom.agencies

            //发票
            let _invoice = {
                invoicetype: this.invoiceType,
                invoiceheader: this.myInvoiceHeader
            }
            //下单
            let po = {
                productcode: _productId,
                productorderid: _productOrderId,
                paytype: this.payChange === "微信" ? 30 : 20,
                extfunc: ext_func,
                couponcode: this.promocode.couponcode,
                agentcode: this.promocode.agentcode,
                invoice: _invoice,
            }
            this.order(po)
        },
        order(po) {
            constJ.reqCreatePackageOrder(po).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    this.base64str = `data:image/png;base64,` + res.result.strdata
                    this.orderid = res.result.orderid
                    let finalprice = res.result.actualAmount
                    let da = {
                        base64str: this.base64str,
                        orderid: this.orderid,
                        payChange: this.payChange,
                        totalBill: finalprice, //this.actualamount
                    }
                    console.log('po============>')
                    console.log(da)
                    this.$refs.QRPayModal.show(da)
                    this.getOrderContract(this.orderid)
                } else {
                    this.$Message.warning('下单异常,请稍后重试')
                    return
                }
            })
        },
        //获取合同信息
        getOrderContract(orderid) {
            //獲取合同信息
            console.log('获取升级包合同orderid:' + orderid)
            constJ.reqGetOrderContract(orderid).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    //this.showQRAndCheckPayStatus()
                    this.$refs.product_Vip_agreement.createdata(res.item)
                }
            })
        },
        onAgreementAccept() {
            console.log("onAgreementAccept======>")
        },
        payComplete() {
            console.log('支付完成===>')
            this.$emit('payComplete')
        },
        showPackageAgreement() {
            this.$refs.product_Vip_agreement.show()
        },
        showInvoice() {
            console.log('显示发票===>')
            this.modalInvoice = true
            this.$refs.myInvoice.invoicetype = '1'
            this.$refs.myInvoice.invoiceTotal=this.actualamount
            //this.$refs.myInvoice.getInvoice()
        },
        getInvoiceInfo() {
            this.$refs.myInvoice.$refs.formData.validate((valid) => {
                if (valid) {
                    if (this.$refs.myInvoice.formData.headertype == 1) {
                        this.$refs.myInvoice.formData.headercode = ''
                        this.$refs.myInvoice.formData.officeaddress = ''
                        this.$refs.myInvoice.formData.mobilenumber = ''
                        this.$refs.myInvoice.formData.bankname = ''
                        this.$refs.myInvoice.formData.bankaccount = ''
                        // this.$refs.myInvoice.formData.postaddress = ''
                        // this.$refs.myInvoice.formData.postemail = ''
                        // this.$refs.myInvoice.formData.postmobile = ''
                    }
                    this.sonheadertype = Number(this.$refs.myInvoice.formData.headertype)
                    console.log(this.sonheadertype);
                    this.$refs.myInvoice.remData = JSON.parse(JSON.stringify(this.$refs.myInvoice.formData))
                    this.$refs.myInvoice.remheadertype = this.$refs.myInvoice.formData.headertype
                    let _invoiceType = this.$refs.myInvoice.invoicetype
                    let invoiceHeader = { ...this.$refs.myInvoice.formData }
                    //this.invoiceHeaderName = this.$refs.myInvoice.formData.headername
                    this.invoiceHeaderName = this.$refs.myInvoice.formData.headertype == 1 ? '个人' : '单位'
                    this.invoiceType = Number(_invoiceType)
                    this.myInvoiceHeader = invoiceHeader
                    this.myInvoiceHeader.headertype = Number(invoiceHeader.headertype)
                    this.modalInvoice = false
                    // console.log(this.invoiceType, invoiceHeader, this.invoiceHeaderName)
                } else {
                    this.$Message.error('请填写必填项！');
                    return
                }
            })

        },
        // getInvoiceInfo() {
        //     this.$refs.myInvoice.$refs.formData.validate((valid) => {
        //         if (valid) {
        //             let _invoiceType = this.$refs.myInvoice.invoicetype
        //             let invoiceHeader = { ...this.$refs.myInvoice.formData }
        //             this.invoiceHeaderName = this.$refs.myInvoice.formData.headername
        //             this.invoiceType = Number(_invoiceType)
        //             this.myInvoiceHeader = invoiceHeader
        //             this.myInvoiceHeader.headertype = Number(invoiceHeader.headertype)
        //             this.modalInvoice = false
        //             console.log(this.invoiceType, invoiceHeader, this.invoiceHeaderName)
        //         } else {
        //             this.$Message.error('请填写必填项!');
        //             return
        //         }
        //     })

        // },
        cancelInvoice() {
            this.modalInvoice = false
        },
        onRowChange(value) {
            console.log(this.packages)
            console.log(this.vipData)
            let row = this.userleveldata
            this.showPayDiscount(row)
        },
        showPayDiscount(row) {
            console.log(this.vipData)
            console.log(this.packages)
            let ext_func = []
            let _productId = row.productcode
            let _productOrderId = row.orderid

            let leftVipData = []
            var that = this
            this.packages.forEach(function(item) {
                let func = that.vipData.find(p => p.funcname === item)
                if (func) {
                    leftVipData.push(func)
                }

            })
            leftVipData.forEach(function(item) {
                let arr = {
                    func_code: item.funccode,
                    func_name: item.funcname,
                    number: item.firstbought,
                }
                if (arr.number > 0) {
                    ext_func.push(arr)
                }

            })
            let po = {
                productcode: _productId,
                productorderid: _productOrderId,
                paytype: 30,
                extfunc: ext_func
            }
            console.log("续费获取价格==>")
            console.log(po)
            constJ.reqPackageDiscount(po).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    //根据返回的折扣，修改价格
                    let pkgdiscount = {
                        orderamount: res.result.orderamount,
                        actualamount: res.result.actualamount
                    }
                    this.vipOrderDays = res.result.days
                    this.vipDiscount = res.result.discountdescdetail
                    this.orderamount = pkgdiscount.orderamount
                    this.actualamount = pkgdiscount.actualamount

                    //拷贝原始价格
                    let _copy = {
                        oriprice: this.actualamount
                    }
                    this.copydata = JSON.stringify(_copy)
                    // //显示ui
                    // this.modalPurchase = true

                    //获取发票信息
                    // var that = this
                    // this.$refs.myInvoice.getInvoice().then(function (resp) {
                    //   console.log('续费VIP包读取发票信息完成...')
                    //   that.getInvoiceInfo()
                    // })

                    // var _that = this
                    // this.$refs.myInvoice.getInvoice().then(function(resp) {
                    //     console.log(resp)
                    //     console.log('读取发票信息完成...')
                    //     if (resp.rltcode === 1 && resp.rtncode === 1) {
                    //         _that.getInvoiceInfo()
                    //     } else {
                    //         //设置初次默认
                    //         _that.$refs.myInvoice.formData.headertype = "1"
                    //         _that.$refs.myInvoice.formData.headername = '个人'
                    //         //_that.getInvoiceInfo()
                    //     }

                    // })

                    //读取发票信息
                    this.$refs.myInvoice.getInvoice()
                    //this.$refs.myInvoice.invoiceTotal=this.actualamount

                    //控制支付状态
                    if (this.actualamount === 0) {
                        this.$emit('disablePay', true)
                    } else {
                        this.$emit('disablePay', false)
                    }
                }
            })

        },
        popAgreement(value) {
            this.$emit('agreement', value)
            console.log(this.agreementChecked)
        },
        payFinished() {
            this.$Message.success('您的账号续费成功')
            this.modalRenewalPay = false
        },
        closePayModal() {
            this.modalRenewalPay = false
        },
        showPayModal() {
            this.modalRenewalPay = true
        },
        //获取vip升级包列表信息
        getProductPackages(row) {
            console.log("获取vip升级包信息=================>")
            //console.log(this.userData.myextentionpackage)
            //获取初次购买vip信息
            console.log(row)
            console.log(this.userData.myvippackage)

            // console.log(this.userData.myvippackage[0].productcode)
            // console.log(row.productcode)


            if (this.userData.myvippackage.length > 0 && this.userData.myvippackage[0].productcode === row.productcode) {
                if (this.userData.myextentionpackage.funcs &&
                    this.userData.myextentionpackage.funcs.length > 0) {
                    this.firstVipData = this.userData.myextentionpackage.funcs
                }
            }

            // if (this.userData.myextentionpackage.funcs &&
            //     this.userData.myextentionpackage.funcs.length > 0) {
            //     this.firstVipData = this.userData.myextentionpackage.funcs
            // }







            //console.log(this.firstVipData)

            let productId = row.productcode
            let productOrderId = row.orderid
            constJ.reqProductPackages(productId, productOrderId).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {



                    this.vipDiscount = res.items.discountdescdetail
                    this.vipOrderDays = res.items.days
                    let myvip = res.items.funcs

                    //处理种子用户一键上传默认数量1
                    if (productId === '000001') {
                        let li = myvip.find(p => p.funccode === '000009')
                        if (li.alreadybought === 0) {
                            li.alreadybought = 1
                        }
                    }

                    console.log('-==============================>')
                    console.log(myvip)
                    //设置vip产品列表
                    this.vipData = myvip
                    this.packages = Array.from(myvip, (x) => x.funcname)
                    console.log(this.packages)
                    //设定第一次购买的vip数据
                    var that = this
                    console.log('===========>')
                    console.log(this.firstVipData)
                    let newVipData = []
                    if (this.firstVipData.length > 0) {
                        this.firstVipData.forEach(function(item) {
                            let v = that.vipData.find(p => p.funccode === item.funccode)
                            //计算默认填充的数量是否超出可以购买上限
                            if (item.alreadybought < (v.maxactive - v.alreadybought)) {
                                v.firstbought = item.alreadybought
                            } else {
                                if (v.maxactive - v.alreadybought > 0) {
                                    v.firstbought = (v.maxactive - v.alreadybought)
                                } else {
                                    v.firstbought = 0
                                }

                            }

                            newVipData.push(v)
                        })
                    } else {
                        this.vipData.forEach(function(item) {
                            item.firstbought = 0
                            newVipData.push(item)
                        })
                    }
                    //设置新的vip列表增加了firstbought
                    let renewVipData = []
                    if (newVipData.length > 0) {
                        newVipData.forEach(function(item) {
                            if (item.alreadybought >= item.maxactive) {
                                item._disable = true
                            } else {
                                item._disable = false
                            }
                            renewVipData.push(item)
                        })
                        this.vipData = []
                        this.vipData = renewVipData
                    }
                    console.log('设置新的vip列表===>')
                    console.log(renewVipData)
                    this.showPayDiscount(row)
                }
            })
        },
        loadDefaultPackages(row) {
            var that = this
            console.log('loadDefaultPackages-----')
            console.log(row)
            //清空价格
            this.actualamount = 0
            this.orderamount = 0

            this.userleveldata = row
            let st = moment(row.starttime).format("YYYY.MM.DD")
            let et = moment(row.endtime).format("YYYY.MM.DD")
            this.userleveldata.name = this.userleveldata.productname + '(' + st + ' - ' + et + ')'
            this.shopList = []
            this.shopList.push(this.userleveldata)
            this.getProductPackages(row)

            //清空优惠券信息
            this.$refs.mycoupon.clean()

        },
        popClose() {
            //传送到购买升级包页面时，关闭当前modal
            console.log('ffffffffffff')
            this.$emit('closeModal')
            //console.log(this)
        },
        renewalTimeChange(value) {
            console.log(this.vipData)
        },
    },
}
</script>
<style scoped>
@font-face {
    font-family: 'iconfont';
    /* project id 1804652 */
    src: url('//at.alicdn.com/t/font_1804652_306rskp3iol.eot');
    src: url('//at.alicdn.com/t/font_1804652_306rskp3iol.eot?#iefix') format('embedded-opentype'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.woff2') format('woff2'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.woff') format('woff'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.ttf') format('truetype'),
        url('//at.alicdn.com/t/font_1804652_306rskp3iol.svg#iconfont') format('svg');
}

.iconfont {
    font-size: 16px;
    font-family: 'iconfont';
    margin-right: 10px;
}

.user-herder-pay-name {
    font-size: 14px;
    padding-left: 53px;
}

.user-herder-pay-time {
    font-weight: 500;
    font-size: 14px;
    float: right;
    padding-right: 80px;
}

.payAmount {
    font-size: 20px;
    color: #f55d54;
    height: 30px;
}

.labelTxt {
    width: 100%;
    height: 32px;
    line-height: 32px;
    padding: 0 7px;
    text-align: right;
    outline: 0;
    -moz-appearance: textfield;
    color: #666;
}

.labelTxt2 {
    height: 32px;
    line-height: 32px;
    padding: 0 7px;
    text-align: left;
    outline: 0;
    -moz-appearance: textfield;
    color: #666;
    display: inline-block;
    width:180px;
}

/*pay modal*/
.vipmodal/deep/.ivu-modal-body {
    padding: 0px;
}

.vipmodal/deep/.ivu-modal-header {
    background-color: #fee7aa;
}

h2 {
    height: 75px;
    line-height: 50px;
    text-align: center;
}

.scentitle {
    font-size: 10px;
    color: #ccc;
    line-height: 50px;
    text-align: center;
}

.card-title-desc {
    font-size: 12px;
    color: #808695;
    height: 20px;
    line-height: 20px;
    margin-top: 5px;
}

.agreement-content {
    margin-top: 10px;
    margin-right: 20px;
    font-size: 10px;
    text-align: right;
}

.agreement-user {
    font-size: 10px;
    color: #4386f5;
    cursor: pointer;
}

/*发票信息*/
.invoiceContent {
    margin-top: 10px;
    text-align: right;
    margin-right: 12px;

    span {
        padding-left: 10px;
    }
}
</style>